import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useBreadcrumb } from '../context/BreadcrumbContext';

/* Statische Route → Label + übergeordnete Eltern */
const ROUTE_MAP = {
  dashboard:     { label: 'Startseite',       parents: [] },
  rezepte:       { label: 'Alle Rezepte',     parents: [] },
  recipe:        { label: null,               parents: [{ label: 'Alle Rezepte', to: '/rezepte' }] },
  new:           { label: 'Neues Rezept',     parents: [] },
  edit:          { label: 'Rezept bearbeiten',parents: [{ label: 'Meine Rezepte', to: '/my-recipes' }] },
  upload:        { label: 'Rezept scannen',   parents: [] },
  kuehlschrank:  { label: 'Kühlschrank-Scan', parents: [] },
  'my-recipes':  { label: 'Meine Rezepte',    parents: [] },
  einstellungen: { label: 'Einstellungen',    parents: [] },
  einkaufsliste: { label: 'Einkaufsliste',    parents: [] },
  woche:         { label: 'Wochenplaner',     parents: [] },
  pakete:        { label: 'Pakete',           parents: [] },
  preise:        { label: 'Pakete',           parents: [] },
  impressum:     { label: 'Impressum',        parents: [] },
  datenschutz:   { label: 'Datenschutz',      parents: [] },
  agb:           { label: 'AGB',              parents: [] },
  kontakt:       { label: 'Kontakt',          parents: [] },
};

export default function Breadcrumb() {
  const location = useLocation();
  const { pageTitle, setPageTitle } = useBreadcrumb();

  /* Titel bei Seitenwechsel zurücksetzen */
  useEffect(() => {
    setPageTitle(null);
  }, [location.pathname, setPageTitle]);

  const first = location.pathname.replace(/^\//, '').split('/')[0];
  const route = ROUTE_MAP[first];

  if (!route) return null;

  /* Auf der Startseite kein Breadcrumb */
  if (first === 'dashboard') return null;

  const crumbs = [
    { label: 'Startseite', to: '/dashboard' },
    ...route.parents,
    { label: pageTitle || route.label, to: null },
  ];

  return (
    <nav className="breadcrumb" aria-label="Brotkrumennavigation">
      {crumbs.map((crumb, i) => (
        <React.Fragment key={i}>
          {i > 0 && <span className="bc-sep" aria-hidden="true">›</span>}
          {crumb.to ? (
            <Link to={crumb.to} className="bc-link">{crumb.label}</Link>
          ) : (
            <span className="bc-current">{crumb.label}</span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
}
